<template>
    <div class="banner-container">
        <img :src="logoUrl" alt="KoliKlinikka" class="banner" />
    </div>
    <header class="site-header">
        <nav class="nav-links" v-if="!isMobile">
            <router-link to="/">Etusivu</router-link>
            <router-link to="/esittely">Esittely</router-link>
            <router-link to="/hoidot">Hoitomuodot</router-link>
            <router-link to="/hinnasto">Hinnasto</router-link>
            <router-link to="/otayhteytta">Ota yhteyttä</router-link>
        </nav>
        <div class="dropdown" v-if="isMobile">
            <button @click="toggleMenu" class="menu-button">☰</button>
            <ul v-show="menuOpen" class="dropdown-content">
                <li><router-link to="/" @click="closeMenu">Etusivu</router-link></li>
                <li><router-link to="/esittely" @click="closeMenu">Minusta</router-link></li>
                <li><router-link to="/hoidot" @click="closeMenu">Hoitomuodot</router-link></li>
                <li><router-link to="/hinnasto" @click="closeMenu">Hinnasto</router-link></li>
                <li><router-link to="/otayhteytta" @click="closeMenu">Ota yhteyttä</router-link></li>
            </ul>
        </div>
        <div class="social-buttons">
            <a href="https://www.facebook.com/profile.php?id=61575307222556" target="_blank" class="social-button">
                <font-awesome-icon :icon="['fab', 'facebook']" />
            </a>
            <a href="https://www.instagram.com/koliklinikka/" target="_blank" class="social-button">
                <font-awesome-icon :icon="['fab', 'instagram']" />
            </a>
            <a href="mailto:koliklinikka@gmail.com" class="social-button">
                <font-awesome-icon :icon="['fas', 'envelope']" />
            </a>
            <router-link to="/varaa" custom v-slot="{ navigate }">
                <button class="main-button" @click="navigate" role="link">Varaa aika</button>
            </router-link>
        </div>
        <div v-if="menuOpen" class="overlay" @click="closeMenu"></div>
    </header>
</template>

<script>
    export default {
        name: "SiteHeader",
        data() {
            return {
                logoUrl: require('@/assets/koliklinikka_banneri.png'),
                isMobile: window.innerWidth <= 768,
                menuOpen: false,
            };
        },
        methods: {
            toggleMenu() {
                this.menuOpen = !this.menuOpen;

                if (this.menuOpen) {
                    document.addEventListener("click", this.closeMenuOnOutsideClick);
                } else {
                    document.removeEventListener("click", this.closeMenuOnOutsideClick);
                }
            },
            closeMenu() {
                this.menuOpen = false;
                document.removeEventListener("click", this.closeMenuOnOutsideClick);
            },
            checkScreenSize() {
                this.isMobile = window.innerWidth <= 768;
            },
            closeMenuOnOutsideClick(event) {
                if (!event.target.closest(".dropdown")) {
                    this.closeMenu();
                }
            }
        },
        mounted() {
            window.addEventListener("resize", this.checkScreenSize);
        },
        beforeUnmount() {
            window.removeEventListener("resize", this.checkScreenSize);
            document.removeEventListener("click", this.closeMenuOnOutsideClick);
        }
};
</script>

<style scoped>
    .site-header {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ebf3ed;
        color: white;
    }

    .banner-container {
        width: 100%;
        overflow: hidden;
        margin-bottom: 1rem;
    }

    .banner {
        position: relative;
        z-index: 1;
        background-size: 100%;
        width: 100%;
        height: 100%;
        min-height: 100px;
        object-fit: cover;
        background-image: url("@/assets/koliklinikka_banneri.png");
    }

    nav {
        display: flex;
        justify-content: center;
        align-items: center;
    }

        nav a {
            margin: 0 30px;
            color: #006400;
            text-decoration: none;
            font-size: 1.25rem;
            font-weight: bold;
            transition: color 0.3s;
        }

            nav a:hover {
                color: #4CAF50;
                text-decoration: underline;
            }

    .button-container {
        display: flex;
        justify-content: center;
    }

    .icon-button, .main-button {
        margin: 0 10px;
        padding: 10px 20px;
        font-size: 1.2rem;
        cursor: pointer;
        border: none;
        border-radius: 5px;
        transition: background-color 0.3s;
    }

    .social-buttons {
        display: flex;
        align-items: center;
    }

    .social-button {
        margin: 0 10px;
        color: black;
        font-size: 1.5rem;
        transition: color 0.3s;
    }

        .social-button:hover {
            color: gray;
        }

    .main-button {
        background-color: #E2CFC9;
        color: black;
    }

        .main-button:hover {
            background-color: #bc9a94;
        }

    .menu-button {
        background: none;
        border: none;
        font-size: 30px;
        cursor: pointer;
    }

    .dropdown {
        position: relative;
    }

    .dropdown-content {
        position: absolute;
        top: 40px;
        background-color: #dbe9df;
        list-style: none;
        padding: 10px;
        box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.1);
        width: 200px;
    }

        .dropdown-content li {
            text-align: center;
        }

        .dropdown-content a {
            color: #006400;
            text-decoration: none;
            font-size: 1rem;
            font-weight: bold;
            transition: color 0.3s;
            padding: 12px 20px;
            display: inline-block;
        }

            .dropdown-content a:hover, .dropdown-content a:active {
                color: #4CAF50;
                text-decoration: underline;
            }

    @media (max-width: 768px) {
        .company-logo {
            margin: 0 0 1rem 0;
        }

        .social-buttons {
            align-items: center;
        }

        .button-container {
            flex-direction: column;
            align-items: center;
        }

        .main-button {
            margin: 10px 0;
        }
    }
</style>
